import { ExamStepsListPage } from "@/features/exam-steps/pages/ExamSteps";

const ExamStepsList = () => {
  return <ExamStepsListPage />;
};

export default ExamStepsList;
